import { useLanguage } from "@/i18n";
import { AccentText, Reveal } from "@/components/Reveal";

export const Manifesto = () => {
    const { t } = useLanguage();
    const chapters = t("manifesto.chapters");

    return (
        <section id="chi-siamo" data-testid="manifesto-section" className="mx-auto max-w-[1600px] px-5 py-24 md:px-12 md:py-32 lg:px-24 lg:py-40">
            <div className="grid gap-16 lg:grid-cols-12 lg:gap-12">
                <div className="lg:col-span-7">
                    <Reveal>
                        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-midora-red" data-testid="manifesto-overline">
                            {t("manifesto.overline")}
                        </p>
                        <h2 className="max-w-xl font-display text-4xl font-light leading-tight tracking-tighter sm:text-5xl" data-testid="manifesto-heading">
                            <AccentText text={t("manifesto.heading")} accentKey="manifesto" />
                        </h2>
                    </Reveal>

                    <div className="mt-16 md:mt-24">
                        {chapters.map((c, i) => (
                            <Reveal key={c.num} delay={i * 0.08} className={`border-t border-white/10 py-10 md:py-12 ${i === 1 ? "md:ml-16" : i === 2 ? "md:ml-32" : ""}`}>
                                <div className="flex items-start gap-6 md:gap-10">
                                    <span className="font-display text-6xl font-light leading-none text-midora-red/80 md:text-8xl" data-testid={`manifesto-num-${c.num}`}>
                                        {c.num}
                                    </span>
                                    <div>
                                        <h3 className="font-display text-2xl font-light italic tracking-tight md:text-3xl">{c.title}</h3>
                                        <p className="mt-3 max-w-md text-sm leading-relaxed text-[#DBD1BD]/60 md:text-base">{c.text}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                <div className="lg:col-span-5">
                    <Reveal delay={0.15} className="lg:sticky lg:top-32">
                        <div className="group overflow-hidden border border-white/10">
                            <img
                                src="/assets/midora-spread.jpg"
                                alt="Selezione Midora"
                                className="aspect-[4/5] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
                                data-testid="manifesto-image"
                            />
                        </div>
                        <div className="mt-8 border-l-2 border-midora-red pl-6">
                            <h3 className="font-display text-xl font-light italic md:text-2xl" data-testid="philosophy-title">
                                {t("manifesto.philosophy.title")}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-[#DBD1BD]/60" data-testid="philosophy-text">
                                {t("manifesto.philosophy.text")}
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};
